import { Box, Typography } from '@mui/material';
import { colors } from '../../../constants/globalcss';
import { AccountInfo } from '@azure/msal-browser';

interface DashboardHeaderProps {
  activeAccount: AccountInfo | null | undefined;
}

const DashboardHeader = ({ activeAccount }: DashboardHeaderProps) => {
  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primary}dd 100%)`,
        borderRadius: 3,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        color: colors.text.light,
        mb: 4,
        p: 4,
        position: 'relative',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontSize: { md: '2.125rem', xs: '1.65rem' },
          fontWeight: 600,
          mb: 1,
          position: 'relative',
        }}
      >
        Welcome, {activeAccount?.name || 'User'}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: { md: '1.125rem', xs: '1.05rem' },
          opacity: 0.95,
          position: 'relative',
        }}
      >
        Submit new requests or review your recent submissions
      </Typography>
    </Box>
  );
};

export default DashboardHeader;
